import styled from 'styled-components';

export const InfoContainer = styled.section`
  display: flex;
  margin-bottom: 20px;
  
  @media (min-width: 768px) {
    flex-direction: column-reverse;
    grid-column: 1;
    margin-bottom: 90px;
  }
  
  @media (min-width: 1110px) {
    margin-bottom: 60px;
  }
`;

export const InfoPhotoContainer = styled.div`
  width: 95px;
  flex-shrink: 0;
  margin-right: 15px;
  
  border-radius: 6px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    
    object-fit: cover;
    
    &:not(:first-child) {
      display: none;
    }
  }
  
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 190px 95px;
    grid-gap: 2px;
    width: auto;
    margin-right: 0;
  
    border-radius: 12px;
    
    img {
      &:not(:first-child) {
        display: inline-block;
      }
      
      &:first-child {
        grid-column: 1 / 3;
      }
    }
  }
  
  @media (min-width: 1110px) {
    grid-template-rows: 240px 120px;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  @media (min-width: 768px) {
    align-items: flex-start;
    margin-bottom: 20px;
  }
  
  @media (min-width: 1110px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }
`;

export const InfoTypeWrapper = styled.div`
  margin-bottom: 5px;
  
  @media (min-width: 768px) {
    order: 1;
    margin-bottom: 10px;
  }
  
  @media (min-width: 1110px) {
    order: 2;
    width: 100%;
    margin-top: 10px;
  }
`;

export const InfoType = styled.p`
  margin: 0;
  padding: 0;
  
  font-size: 12px;
  line-height: 1;
  
  @media (min-width: 768px) {
    padding: 5px 10px;
    
    font-size: 14px;
    color: ${({ theme }) => theme.white};
    
    background-color: ${({ theme }) => theme.blue};
    border-radius: 50px;
  }
  
  @media (min-width: 1110px) {
    display: inline-block;
  }
`;

export const InfoHeading = styled.h2`
  margin: 0;
  margin-bottom: 10px;
  padding: 0;
  
  font-size: 16px;
  line-height: 1;
  
  @media (min-width: 768px) {
    order: 0;
    margin-bottom: 15px;
    
    font-size: 24px;
  }
`;

export const InfoStars = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: auto;
  
  @media (min-width: 768px) {
    order: 3;
  }
  
  @media (min-width: 1110px) {
    order: 1;
    margin-top: 5px;
    margin-bottom: 0;
  }
`;

export const InfoVotes = styled.span`
  margin-left: 5px;

  font-size: 12px;
  line-height: 1;
  color: ${({ theme }) => theme.blue};
`;

export const InfoAddress = styled.p`
  display: flex;
  align-items: flex-start;
  margin: 0;
  padding: 0;

  font-size: 10px;
  line-height: 12px;

  svg {
    flex-shrink: 0;
    margin-right: 5px;
  }
  
  @media (min-width: 768px) {
    order: 2;
    
    font-size: 14px;
    line-height: 1;
  }
  
  @media (min-width: 1110px) {
    width: 100%;
    margin-bottom: 0;
  }
`;
